// extracted by mini-css-extract-plugin
module.exports = {"header":"styles_header__1fkIz","container":"styles_container__1pm9F","title":"styles_title__3Cgyj","wrapper":"styles_wrapper__7DdZn","answer":"styles_answer__3Txsq"};